(function($) {

    var init_swiper = function() {
        setTimeout(function(){

            var imageSwiper = new Swiper('.swiper-shop', {
                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
        }, 1000);
    };
    if ($('#shops').length) {

        $(document).ready(function() {
            $('.js-shop__modal-trigger').click(function(e) {
                e.preventDefault();
                var id = $(this).data('id');
                data = {action: 'get_shop', id: id};
                $.post(MyAjax.ajaxurl, data, function(response) {
                    $('#shop-modal .modal-content').html(response);
                    $('#shop-modal').modal('show');
                    init_swiper();
                });
            });

            var filterizd = $('.filtr-container').filterizr({
                //options object
                delay: 0,
            });
            $('.filter__item').click(function() {
                $('.filter__item').removeClass('filter__item--active');
                $(this).addClass('filter__item--active');
            });
            if (window.location.hash) {
                var filter = window.location.hash.substring(1);
                $('.filter__item[data-filter=' + filter + ']').click();
            }
        });
    }
}(jQuery, window));